import React, { useState, useEffect} from 'react';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { animate, motion } from 'framer-motion';

import { images } from '../../constants';

import { AppWrap, MotionWrap } from '../../wrapper';


import './Work.scss';

const Work = () => {


  

  const [activeFilter, setactiveFilter] = useState("All")
  const [animateCard, setanimateCard] = useState({y: 0, opacity: 1})

  const [works, setworks] = useState([
    {
      "title": "Crypto Hub",
      "name": "CryptoHub",
      "imgURL": images.CryptoHub,
      "description": "Modern crypto tracking website that will allow user to search for price, market cap and history data of a specific coin",
      "projectLink": "https://cryptohubtracker.netlify.app/",
      "CodeLink": "https://github.com/PopeUni/CryptoHub",
      "tags": ["ReactJS", "All", "API"],
    },
    {
      "title": "Realtor Realestate",
      "name": "Realtor",
      "imgURL": images.realtor,
      "description": "Real estate website created using data from bayut api that will allow users to filter and search for specific properties",
      "projectLink": "https://realtor-realestate.vercel.app/",
      "CodeLink": "https://github.com/PopeUni/realtor_realestate",
      "tags": ["NextJS", "All", "API", "ReactJS"],
    },

    {
      "title": "Fitness Trainer",
      "name": "Fitness Trainer",
      "imgURL": images.fitnessTrainer,
      "description": "Mobile fitness app landing page made with bootstrap that will display the unique features prices and testimonials of the app",
      "projectLink": "https://popeuni.github.io/FitnessTrainer/",
      "CodeLink": "https://github.com/PopeUni/FitnessTrainer",
      "tags": ["Bootstrap","All"],
    },

    {
      "title": "Keeper",
      "name": "Keeper",
      "imgURL": images.keeper,
      "description": "Note tracking application that will allow users to store any imporant notes they wish to write down and help them remember",
      "projectLink": "https://ukeeper.netlify.app/",
      "CodeLink": "https://github.com/PopeUni/keeper",
      "tags": ["React","All"],
    },

    {
      "title": "Weather Scanner",
      "name": "Weather Scanner",
      "imgURL": images.WeatherApp,
      "description": "Simple weather application using created using openweathermap api that will display current weather data for a city of the users choice",
      "projectLink": "https://popeuni.github.io/WeatherApp/",
      "CodeLink": "https://github.com/PopeUni/WeatherApp",
      "tags": ["API","All"],
    },

    {
      "title": "Scheduling Algorithms",
      "name": "Scheduling Algorithms",
      "imgURL": images.scheduling,
      "description": "Testing and comparing results from different types of scheduling algorithms such as first come first serve and shortest remaining time",
      "projectLink": "https://github.com/PopeUni/SchedulingAlgorithms",
      "CodeLink": "https://github.com/PopeUni/SchedulingAlgorithms",
      "tags": ["Java","All"],
    },


    {
      "title": "Maze Generator and Solver",
      "name": "Maze Generator and Solver",
      "imgURL": images.maze,
      "description": "Generate a random n * m sized maze using a depth first search algorithm and then by using the data given, solve it using a DFS approach",
      "projectLink": "https://github.com/PopeUni/DFSMazeGeneratorAndSolver",
      "CodeLink": "https://github.com/PopeUni/DFSMazeGeneratorAndSolver",
      "tags": ["Java","All"],
    },

  ])
  const [filterWork, setFilterWork] = useState(works);

  const handleWorkFilter = (item) => {

    setactiveFilter(item);
    setanimateCard([{y:100, opacity:0}])

    setTimeout(() => {
      setanimateCard([{y:0, opacity: 1}])

      if(item === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)))  
      }
    }, 500)

  }


  useEffect(() => {

   // setFilterWork(works)

  })

  //setFilterWork(works)


  return (
    
    <>
      <h2 className='work-text'>
      My Creative <span>Portfolio</span> Section<br /> 
      </h2>

      <div className='app__work-filter'>
      {['Java', 'API', 'Bootstrap', 'ReactJS', 'All'].map((item,index) => (
          <div
          key={index}
          onClick={() => handleWorkFilter(item)}
          className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active': '' }`}
          > 
          {item}
          </div>
        ))}
      </div>

      <motion.div
      animate={animateCard}
      transition={{duration: 0.5, delayChildren: 0.5}}
      className = "app__work-portfolio"
      >

        {filterWork.map((work, index) => (

          <div className="app__work-item app__flex" key={index}>
            <div className='app__work-img app__flex'>
              <img src={work.imgURL} alt={work.name} />

              <motion.div
              whileHover={{opacity: [0,1]}}
              transition={{duration:0.25, ease: 'easeInOut', staggerChildren: 0.5}}
              className="app__work-hover app__flex"
              >
                <a href={work.projectLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{scale: [0,1]}}
                    whileHover={{scale: [1,0.9]}}
                    transition={{duration:0.25,}}
                    className="app__flex"
                  >
                  <AiFillEye />
                  </motion.div>
                </a>

                <a href={work.CodeLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{scale: [0,1]}}
                    whileHover={{scale: [1,0.9]}}
                    transition={{duration:0.25,}}
                    className="app__flex"
                  >
                  <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className='app__work-content app__flex'>
              <h4 className='bold-text'>{work.title}</h4>
              <p className='project-text' style={{marginTop: 10}}>{work.description}</p>
           
              <div className='app__work-tag app__flex'>
                <p className='project-text'>{work.tags[0]}</p>
              </div>
           
           
            </div>

          </div>

        ))}

      </motion.div>
    </>

  )
}

//export default AppWrap(Work, "work")

export default AppWrap(
  MotionWrap(Work, 'app__works'), 
  'work',
  "app__primarybg"
  );